import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=6c1e6f7e&scoped=true"
import script from "./tongji.vue?vue&type=script&lang=js"
export * from "./tongji.vue?vue&type=script&lang=js"
import style0 from "./tongji.vue?vue&type=style&index=0&id=6c1e6f7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e6f7e",
  null
  
)

export default component.exports